module.exports = __webpack_public_path__ + "media/images/fbcalls/fb_for_bg-7ae96871aa3011f6f992568ea97d6618.png";